module.exports = __webpack_public_path__ + "static/media/pa.68029990.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/pa.svg
// module id = 218
// module chunks = 0